import React, { useMemo, useState } from "react";
import Style from "./AfterLoginHeader.module.css";
import { Navbar, Container, OverlayTrigger } from "react-bootstrap";
import { MdOutlineNotifications } from "react-icons/md";
import HeaderNotification from "../HeaderNotification/HeaderNotification";
import { useDispatch, useSelector } from "react-redux";
import { imageUrl } from "../../config/apiUrl";
// import { ProfileImg } from "../../constant/imagePath";
import profileImg from "../../assets/images/brandCard2.png";
import { useNavigate } from "react-router-dom";
import { clearNotiData } from "../../store/common/commonSlice";

export const AfterLoginHeader = ({ className }) => {
  const navigate = useNavigate();
  const diapatch = useDispatch();
  const [showNotificationOverlay, setShowNotificationOverlay] = useState(false);
  const { user } = useSelector((state) => state?.authReducer);
  const noti_counter = useSelector(
    (state) => state?.commonReducer?.noti_counter
  );

  return (
    <Container className={`${[Style.navbarContainer, className].join(" ")}`}>
      <div className={[Style.iconDiv].join(" ")}>
        {/* <OverlayTrigger
          placement={"bottom"}
          show={showNotificationOverlay}
          trigger={["click"]}
          overlay={
            <div className={[Style.notifyoverlayDiv]}>
              <HeaderNotification />
            </div>
          }
          onToggle={() => setShowNotificationOverlay(!showNotificationOverlay)}
        > */}
        <div
          className={Style.notiIcon}
          onClick={() => {
            diapatch(clearNotiData());
            navigate("/notification");
          }}
        >
          <MdOutlineNotifications color={"var(--white-color)"} size="30px" />
          {noti_counter > 0 && (
            <div className={Style.notiCount}>{noti_counter}</div>
          )}
        </div>
        {/* </OverlayTrigger> */}
      </div>
      <div className={Style.userWrap}>
        <p>{user?.userName}</p>
        <div className={[Style.profileImg]}>
          <img
            src={`${imageUrl(user?.photo)}`}
            alt="..."
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = profileImg;
            }}
          />
        </div>
      </div>
    </Container>
  );
};
